var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("write-my-name " + (_vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: 'calc(100% - 96px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.showWriting ? _c('write-my-name', {
    attrs: {
      "show-done": _vm.isDoneBtnEnabled,
      "written-name": _vm._f("capitalize")(_vm.writtenName),
      "on-done-click": _vm.showDisplayMyName
    }
  }) : _vm._e(), _vm.showPrint ? _c('display-my-name', {
    attrs: {
      "show-done": _vm.isDoneBtnEnabled,
      "show-print": !_vm.isIOSApp,
      "end-round": _vm.handleRoundEnd,
      "open-print-dialog": _vm.openPrintDialog,
      "written-name": _vm._f("capitalize")(_vm.writtenName)
    }
  }) : _vm._e()], 1)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }